import './js/scaleRoot.2.js';
import './js/scrollFrame.2.js';
import { MJPromotion } from './js/promotion2.js'

import lozad from 'lozad';

class Boot {
  getElementsDevice() {
    const elPc = $('.MS__pc');
    const elMb = $('.MS__mb');
    const isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
    if (isMobile) {
      elPc.remove();
      console.log('Remove MS__pc:', elPc.length);
    } else {
      elMb.remove();
      console.log('Remove MS__mb:', elMb.length);
    };
  };
  removeLayerLoading() {
    setTimeout(() => {
      $('.MS__layer-loading, .layer').hide();
      console.log('Element Layer hidden');
    }, 4000);
  }
  onScale(callback) {
    $("#MS__wrapper, .MS__outer").addClass("scaleDesktop scaleMobile");

    let $firstImg;
    const isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
    if (isMobile) {
      $firstImg = $('#MS__wrapper section .background img.MS__mb').first();
    } else {
      $firstImg = $('#MS__wrapper section .background img.MS__pc').first();
    };
    function applySize() {
       // const $section = $firstImg.closest('section');
      // $section.css({
      //   width: $firstImg.width() + 'px',
      //   height: $firstImg.height() + 'px'
      // });

      $('.MJ__readyScale').css({
        position: 'relative',
        zIndex: '10',
        width: $firstImg.width() + 'px',
        height: $firstImg.height() + 'px'
      });
      $("#MS__wrapper, .MS__outer").scalePlatform();
      console.log('First image loaded - scalePlatform triggered');
    }

    if ($firstImg[0].complete) {
      applySize(); // ảnh đã load sẵn
    } else {
      $firstImg.on('load', applySize); // chờ load mới xử lý
    }

    window.addEventListener("load", function () {
      console.log('HTML,CSS,JS loaded');
      $("#MS__wrapper, .MS__outer").scalePlatform(callback);

    });
    $(window).on("resize", function () {
      $("#MS__wrapper, .MS__outer").scalePlatform();
    });
  };
  async lazyLoad() {
    console.log("Found elements lazyloads:", $('.MS__lazyload, .MJ__lazyload').length);
    const observer = lozad('.MS__lazyload, .MJ__lazyload', {
      loaded: function (el) {
        el.classList.add('MJ__loaded', 'MJ__lazyload');

      }
    });
    observer.observe();
    console.log("Lozad loaded successfully");
  };
  async disableHref() {
    $('a[href="#"]').on('click', function (event) {
      var hrefValue = $(this).attr('href');
      if (hrefValue === '#') {
        event.preventDefault();
      }
    });
  };
  async loadBundles() {
    const listBundles = varMS.bundles;

    const loadScript = (src, globalVar) => {
      return new Promise((resolve, reject) => {
        if (window[globalVar]) {
          console.log(`${globalVar} already loaded from CDN`);
          return resolve(window[globalVar]);
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => {
          console.log(`${globalVar} loaded successfully`);
          resolve(window[globalVar]);
        };
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
      });
    };

    const loadCSS = (href) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`link[href="${href}"]`)) {
          console.log(`CSS already loaded: ${href}`);
          return resolve();
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = () => {
          console.log(`CSS loaded: ${href}`);
          resolve();
        };
        link.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));
        document.head.appendChild(link);
      });
    };

    for (const key in listBundles) {
      if (listBundles[key] === false) continue;

      try {
        switch (key) {
          case 'jquery':
        
          window.$ = jQuery;
            break;
          case 'lodash':
            await loadScript("https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js", "_");
            break;
          case 'swiper':
            await loadScript("https://unpkg.com/swiper@11.2.8/swiper-bundle.min.js", "Swiper");
            await loadCSS("https://unpkg.com/swiper@11.2.8/swiper-bundle.min.css");
            break;
          case 'fancybox':
            await loadScript("https://cdn.jsdelivr.net/npm/@fancyapps/ui@4/dist/fancybox.umd.min.js", "Fancybox");
            await loadCSS("https://cdn.jsdelivr.net/npm/@fancyapps/ui@4/dist/fancybox.min.css");
            break;
          case 'animate':
            await loadCSS("https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css", "animate");
            break;
        }
      } catch (error) {
        console.error(`Failed to load ${key} from CDN:`, error);
      }
    }
  }
  async run() {
    this.getElementsDevice()
    this.removeLayerLoading();
    this.onScale(() => new libraryMJ().loadVideo())

    await Promise.all([
      this.disableHref(),
      this.lazyLoad(),
      this.loadBundles()
    ]);
  }
};
class libraryMJ {
  async onClosePopup() {
    $('.MJ__close-popup').on('click', function (e) {
      $(this).closest('.MS__popup').removeClass("active");
      return false;
    });
  };
  async onToogleActive() {
    $(".MJ__toogleActive").on("click", function (e) {
      const target = $(this).data("target");
      $(target).toggleClass("active");
      e.preventDefault();
      return false;
    });
  };
  async onOpenIframe() {
    $('.MJ__openIframe').on("click", function (e) {
      const linkIframe = $(this).data("link");
      const targetIframe = $(this).data("iframe");
      $(targetIframe).attr('src', linkIframe);
      e.preventDefault();
      return false;
    });
  };
  async loadVideo() {
    const listVideos = $('.MJ__loadVideo');
    if (listVideos.length === 0) return;

    listVideos.each(function (index, element) {
      const $this = $(this);

      // Nếu đã có thẻ <video> bên trong thì bỏ qua
      if ($this.find('video').length > 0) return;

      const videoSrc = $this.data('video');
      $this.append(`
      <video width="100%" height="auto" playsinline muted autoplay loop loading="lazy" style="position: absolute; top: 0; left: 0;">
        <source src="${videoSrc}" type="video/mp4">
      </video>
    `);
    });
  }
  async run() {
    await Promise.all([
      this.onClosePopup(),
      this.onToogleActive(),
      this.onOpenIframe(),
    ]);
  }
};
class Core {
  constructor() {
    this.init();
  };
  promotion(object) {
    new MJPromotion(object);
  };
  async init() {
    await Promise.all([
      await new Boot().run(),
      await new libraryMJ().run()
    ]);
  };
}

window.libraryMainsite = new Core();
